import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom'

import auth from '../../lib/Auth'
import { Location } from './types'
import { useAccessLevel } from '../../store/user'
import { componentDidMount } from './LoginService'

interface Props {
  location: Location
}

export const Login: React.FC<Props> = ({ location }) => {
  const mounted = useRef(false)
  const dispatch = useDispatch()
  const accessLevel = useAccessLevel()

  const state = location?.state
  const [show, setShow] = useState<boolean>(false)
  const [referrer, setReferrer] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!mounted.current) {
      componentDidMount(location, dispatch, setShow, setReferrer)
      mounted.current = true
      return
    }
  }, [location, dispatch])

  if (!accessLevel.isLoggedIn) {
    show && auth.login(state && state.referrer)

    return null
  }

  const redirectUrl = (state && state.referrer + state.search) || referrer || '/'

  return <Redirect to={redirectUrl} />
}

export default Login
